import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SupportChatbotService {
  readonly open$ = new BehaviorSubject<boolean>(false);

  openPanel() { this.open$.next(true); }
  toggle() { this.open$.next(!this.open$.value); }
}
